import axios from "./axios";
import { IAuth, IUser } from "../types/user";

export const signinApi = async (data: IAuth): Promise<IUser> => {
    return await axios.post("/sign-in/", data);
};

export const signoutApi = async () => {
    return await axios.post("/sign-out/");
};